import { colors, chartColors } from "../../theme";
import { BRAND_COLORS, brandRgba } from "../../utils/brandAssets";

export const heroGradient = `linear-gradient(135deg, ${colors.background} 0%, ${colors.paper} 40%, ${brandRgba(BRAND_COLORS.cyan, 0.12)} 70%, ${brandRgba(BRAND_COLORS.cyan, 0.08)} 100%)`;

export const marketingKeyframes = {
  "@keyframes gradientShift": {
    "0%, 100%": { backgroundPosition: "0% 50%" },
    "50%": { backgroundPosition: "100% 50%" },
  },
  "@keyframes float": {
    "0%, 100%": { transform: "translateY(0px)" },
    "50%": { transform: "translateY(-8px)" },
  },
  "@keyframes pulseGlow": {
    "0%, 100%": { opacity: 0.4 },
    "50%": { opacity: 0.7 },
  },
  "@keyframes shimmer": {
    "0%": { backgroundPosition: "-200% 0" },
    "100%": { backgroundPosition: "200% 0" },
  },
};

export const accentColors = [BRAND_COLORS.cyan, ...chartColors.slice(1)];

export const glowOrb = (color, size = 280) => ({
  position: "absolute",
  width: size,
  height: size,
  borderRadius: "50%",
  background: `radial-gradient(circle, ${color}22 0%, transparent 70%)`,
  filter: "blur(40px)",
  pointerEvents: "none",
});

/** Consistent icon sizing across marketing surfaces (matches home QuickActions). */
export const marketingIconSizes = {
  feature: 22,
  social: 20,
  matchup: 18,
  chip: 14,
};

export const featureIconBox = (accent) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: 44,
  height: 44,
  borderRadius: 1.5,
  bgcolor: `${accent}18`,
  color: accent,
  mb: 2,
  flexShrink: 0,
  "& .MuiSvgIcon-root": { fontSize: marketingIconSizes.feature },
});

export const socialProofIconBox = (accent) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: 40,
  height: 40,
  borderRadius: 1.5,
  bgcolor: `${accent}14`,
  color: accent,
  flexShrink: 0,
  "& .MuiSvgIcon-root": { fontSize: marketingIconSizes.social },
});

export const matchupVsBadge = (accent) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: 36,
  height: 36,
  borderRadius: "50%",
  bgcolor: `${accent}14`,
  border: `1px solid ${accent}33`,
  color: accent,
  flexShrink: 0,
  "& .MuiSvgIcon-root": { fontSize: marketingIconSizes.matchup },
});
